import { render, staticRenderFns } from "./StudyTable.vue?vue&type=template&id=c8956aa8&scoped=true&"
import script from "./StudyTable.vue?vue&type=script&lang=js&"
export * from "./StudyTable.vue?vue&type=script&lang=js&"
import style0 from "./StudyTable.vue?vue&type=style&index=0&id=c8956aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8956aa8",
  null
  
)

export default component.exports